import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';

export const useRingSocket = (rootPath) => {
    const EMIT_RING_BET = async (
        data: {
            amount: string;
            frontID: number;
            isFast: boolean;
            risk: string;
            segments: number;
        },
        callback?: (res: any) => any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return await asyncEmit<{
            roll_number: string;
            winAmount: number;
            [key: string]: any; // 前端将追加其它值
        }>(`${rootPath}.ring.bet`, data);
    };

    return {
        EMIT_RING_BET,
    };
};
